<template>
	<div class="main">
		<div class="p-5 w-50">
			<h1>FrontEnd Testing</h1>
			<transition name="fade">
				<Alert v-if="hasAlert" :alert="alert" />
			</transition>
			<Downloads
				:value="empty"
				:visibilities="downloadTypes || []"
			/>

		</div>
	</div>
</template>
<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
	mixins: [DisplaysAlerts],
	data() {
		return {
			empty: [],
			downloadTypes: [
				{
					label:"Everyone",
					value:"ALL_USERS"
				},
				{
					label:"Else",
					value:"ALL_ELSE"
				}
			]
		};
	}
}
</script>
